/**
 * Unread, said only as honestly as it can be (spec #44 §4,
 * §Provisional 3).
 *
 * A DOT is what an agent channel gets: `head.latest_at[domain]` moved past
 * the reader's watermark, which is free and true. An exact COUNT appears
 * only where one is both honest and cheap — `# needs-you` (a real count of
 * open items) and the channel already open (counted from the page already
 * fetched). Nothing here estimates.
 */

import styles from './workspace.module.css';

export function UnreadBadge({
  domain,
  count,
}: {
  /** Used for the test id and the label; not rendered as text. */
  domain: string;
  /** Omit for a dot. A number renders the exact count. */
  count?: number;
}) {
  if (count === undefined) {
    return (
      <span
        className={styles.unreadDot}
        data-testid={`unread-${domain}`}
        role="img"
        aria-label="Unread activity"
      />
    );
  }
  if (count <= 0) return null;
  return (
    <span
      className={styles.unreadCount}
      data-testid={`unread-count-${domain}`}
      aria-label={`${count} waiting`}
    >
      {count}
    </span>
  );
}
